module.exports = __webpack_public_path__ + "img/bulb.8939cf92.svg";